const Footer = () => {
  return (
    <footer className='footer'>
        <div className='footer-content'>
            <span>Ministerstwo Klimatu i Środowiska</span>
        </div>
    </footer>
  )
}

export default Footer